import { ActivitiesQuery } from '../../../../hcl-sdk-core/src/graphql/types'
import { OKSDK_GEOLOCATION_HISTORY, storageUtils } from '../../utils/storageUtils'
import { NEAR_ME, SEARCH_TARGET } from '../constants'
import { GeoLocationStatus, SearchInputName, SearchMapState, SortValue } from './SearchMapStore.type'
import StoreProvider from './StoreProvider'

export const initStateSearchMapStore: SearchMapState = {
  loading: false,
  loadingActivitiesStatus: 'idle',
  loadingIndividualDetail: false,
  loadingSwitchAddress: false,
  specialties: [],
  specialtiesRaw: [],
  isAllowDisplayMapEmpty: false,
  isResultSearchGeo: {},
  search: {},
  searchGeo: [],
  searchDoctor: [], // HCPs
  searchSpecialty: [],
  searchMedicalTerms: [],
  selectedValues: {},
  selectedActivity: null,
  individualDetail: null,
  sortValues: {
    distanceNumber: false,
    lastName: false,
    name: false,
    relevance: true
  },
  searchFields: {
    name: '', // First name or Last name of HCPs
    specialtyName: '',
    address: '',
    medicalTerm: ''
  },
  locationFilter: null,
  specialtyFilter: [],
  medicalTermsFilter: null,
  geoLocation: {
    status: 'denied' as GeoLocationStatus,
    latitude: 0,
    longitude: 0
  },
  navigatedFromHome: false,
  cachedActivities: {},

  // hco
  searchTarget: undefined,
  selectedHco: null,
  hcoDetail: null,
  hcoDetailServicesLoadMore: {},
  HCOServicesByWorkplaceIdNoLoadmore: {},
  hcos: null,
  loadingHcosStatus: 'idle',
  navigateFromHcoFullCard: false,
  searchHcos: [],
  isShowRelaunchBtn: false
}

class SearchMapStore extends StoreProvider<SearchMapState> {
  constructor(state: SearchMapState) {
    super(state);
    this.state = state;
  }

  setSearchTarget(searchTarget: SEARCH_TARGET) {
    this.setState({
      searchTarget
    })
  }

  get searchTarget() {
    return this.state.searchTarget
  }

  setSortValues(sortValue: SortValue) {
    this.setState({
      sortValues: {
        ...this.state.sortValues,
        ...sortValue,
        distanceNumber: this.isGrantedGeoloc ? sortValue.distanceNumber : 'SORT_DISABLED',
      },
    });
  }

  get sortValues() {
    return {
      ...this.state.sortValues,
      distanceNumber: this.isGrantedGeoloc ? this.state.sortValues.distanceNumber : 'SORT_DISABLED',
    };
  }

  setSearchFieldValue(key: SearchInputName, value: string) {
    this.setState({
      searchFields: {
        ...this.state.searchFields,
        [key]: value
      }
    })
  }

  setGeoLocation({ latitude = 0, longitude = 0 } = {}) {
    this.setState({
      geoLocation: {
        ...this.state.geoLocation,
        status: 'granted',
        latitude,
        longitude
      }
    })

    storageUtils.setObject(OKSDK_GEOLOCATION_HISTORY, {
      latitude,
      longitude,
      time: Date.now()
    })
  }

  getGeoLocation(shorthand: boolean = false) {
    const { latitude, longitude } = this.state.geoLocation;

    if (shorthand) {
      return { 
        lat: latitude, 
        lng: longitude 
      };
    }

    return {
      latitude, 
      longitude
    }
  }

  resetDataSearch({ isResetHCPDetail = false, isResetSearchFields = false, isResetHCODetail = false } = {}) {
    let resetHCPDetail = {}
    let resetSearchFields = {}
    let resetHCODetail = {}

    if (isResetHCPDetail) {
      resetHCPDetail = {
        selectedActivity: null,
        individualDetail: null,
        specialties: [],
        specialtiesRaw: []
      }
    }

    if (isResetSearchFields) {
      resetSearchFields = {
        searchFields: {
          name: '',
          address: '',
          medicalTerm: '',
          specialtyName: '',
        },
        specialtyFilter: [],
        locationFilter: null,
        medicalTermsFilter: null
      }
    }

    if (isResetHCODetail) {
      resetHCODetail = {
        selectedActivity: null,
        individualDetail: null,
        specialties: [],
        specialtiesRaw: []
      }
    }

    this.setState({
      searchDoctor: [],
      searchGeo: [],
      searchSpecialty: [],
      searchMedicalTerms: [],
      searchHcos: [],
      ...resetSearchFields,
      ...resetHCPDetail,
      ...resetHCODetail
    })
  }

  get isGrantedGeoloc() {
    return this.state.geoLocation.status === 'granted';
  }

  get isSearchNearMe() {
    const { locationFilter, searchFields } = this.state
    const { name, specialtyName, medicalTerm, address  } = searchFields

    if (
      !name && !specialtyName && !medicalTerm && address &&
      locationFilter && locationFilter.id === NEAR_ME 
    ) {
      return true
    }

    return false
  }

  getSearchLabel(isRemovedAddr = false) {
    const searchFields = this.state.searchFields
    const { name, specialtyName, address, medicalTerm  } = searchFields

    const firstPart = [name, specialtyName, medicalTerm].filter(s => s).join(', ')
    const greyPart = address ? `<span class="address">${address.toLowerCase()}</span>` : ''

    if (isRemovedAddr) {
      return firstPart
    }

    return [
      firstPart ? `<span>${firstPart}</span>` : ''
      , greyPart].filter(s => s).join('')
  }

  getCached(storeKey: string) {
    if (storeKey && this.state.cachedActivities[storeKey]) {
      return this.state.cachedActivities[storeKey]
    }
    return null
  }

  saveCached(storeKey: string, activities: ActivitiesQuery) {
    if (storeKey && activities) {
      this.state.cachedActivities[storeKey] = activities
    }
  }

  get activities() {
    return {
      isLoading: this.state.loadingActivitiesStatus === 'loading',
      status: this.state.loadingActivitiesStatus,
      data: this.state.specialties
    }
  }

  setActivitiesLoadingStatus(status: 'loading' | 'idle' | 'success' | 'error' | 'unauthorized') {
    this.setState({
      loadingActivitiesStatus: status,
    });
  }

  setHcosLoadingStatus(status: 'loading' | 'idle' | 'success' | 'error' | 'unauthorized') {
    this.setState({
      loadingHcosStatus: status,
    });
  }
}



export default SearchMapStore
